export default [
  {
    key: "otakar",
    title: {
      cs: "Otakar",
      en: "Otakar",
    },
    text: [
      "spaces.meetingrooms.otakar.text.part1",
      "spaces.meetingrooms.otakar.text.part2",
      "spaces.meetingrooms.otakar.text.part3",
    ],
    equipment: [
      "meetingBoard",
      "videoConference",
      "wifi",
      "kitchen",
      "toilet",
      "projector",
      // "soundsystem",
      "speakerDesk",
      "pencils",
      "water"
    ],
    services: ["flipchart", "coffee", "catering", "else"],
    subtitle: "spaces.meetingrooms.otakar.subtitle",
    price: {
      cs: {
        hour: "4 200 Kč / hodina",
        day: "5+ hodin pronájmu 2 500 Kč/hod",
        size: "41 m<sup>2</sup> / až 30 osob",
      },
      en: {
        hour: "CZK 2,500 / hour",
        day: "",
        size: "41 m<sup>2</sup> / 30 people",
      },
    },
    imageList: [
      "/img/Otakar_Zasedaci_mistnost_reprezentativni_k_pronajmu_centrum_Prahy.jpg",
      "/img/Otakar_Pronajmuti_reprezentativni_mistnosti_na_workshop.jpg",
      "/img/Otakar_Atraktivni_lokalita_pronajem_zasedacky_tiskova_konference.jpg",
      "/img/Otakar_Staromestske_namesti_workshop_pronajem_prostoru.jpg",
      "/img/Otakar_flexibilni_zasedaci_mistnost_k_pronajmu_Staromestske_namesti.jpg",
      "/img/Opero_meeting_room_workshops_Prague_1_press_conferences.jpg",
      "/img/Opero_o_nas_Vzdelavame_a_inspirujeme_byznys.jpg",
    ],
    titleImage: "/img/Zasedaci_mistnost_Otakar_pronajem_Praha_1_design.jpg",
    width: 170,
    seoTitle: "Otakar | Zasedací místnost pro 20 až 30 osob | Opero\n",
    seoDescription:
      "V centru Prahy. Vzdušná zasedací místnost ideální pro ✔ tiskovou konferenci ✔  workshop ✔  networking. Zajistíme občerstvení. Přijďte se podívat.\n",
  },
  {
    key: "stenc",
    title: {
      cs: "Štenc",
      en: "Štenc",
    },
    subtitle: "spaces.meetingrooms.stenc.subtitle",
    text: [
      "spaces.meetingrooms.stenc.text.part1",
      "spaces.meetingrooms.stenc.text.part2",
      "spaces.meetingrooms.stenc.text.part3",
    ],
    price: {
      cs: {
        hour: "1 400 Kč / hodina",
        day: "",
        size: "28 m<sup>2</sup> / 10 osob",
      },
      en: {
        hour: "CZK 1,200 / hour",
        day: "",
        size: "28 m<sup>2</sup> / 10 people",
      },
    },
    equipment: [
      "roundTable",
      "comfySeating",
      "meetingBoard",
      "videoConference",
      "flipchart",
      "pencils",
      "water"
    ],
    services: ["coffee", "catering", "else"],
    imageList: [
      "/img/stenc_coworking_byznys_hub_Opero_pronajem_design.jpg",
      "/img/Stenc_detail_Opero_architektura_atraktivni_pracovni_prostredi.jpg",
      "/img/stenc_misto_pro_praci_networking_schuzky_zasedaci_mistnost_pronajem.jpg",
      "/img/Stenc_pronajem_reprezentativni_zasedaci_mistnosti_Praha_1.jpg",
    ],
    titleImage: "/img/Stenc_business_meeting_rent_room_Prague1_Oldtown.jpg",
    width: 150,
    seoTitle: "Štenc | Oceňovaná zasedačka pro 10 osob | Opero \n",
    seoDescription:
      "V centru Prahy. Moderní zasedací místnost ideální pro ✔ jednání s klientem ✔ uzavírání smluv ✔  prezentace. Zajistíme občerstvení. Přijďte se podívat.\n",
  },
  {
    key: "salvator",
    title: {
      cs: "Salvátor",
      en: "Salvátor",
    },
    subtitle: "spaces.meetingrooms.salvator.subtitle",
    text: [
      "spaces.meetingrooms.salvator.text.part1",
      "spaces.meetingrooms.salvator.text.part2",
      "spaces.meetingrooms.salvator.text.part3",
    ],
    equipment: ["meetingBoard", "videoConference", "wifi", "writingWall", "variableTables", "pencils", "water"],
    services: ["flipchart", "coffee", "catering", "else"],
    price: {
      cs: {
        hour: "1 200 Kč / hodina",
        day: "",
        size: "28 m<sup>2</sup> / až 20 osob",
      },
      en: {
        hour: "CZK 900 / hour",
        day: "",
        size: "28 m<sup>2</sup>/ 20 people",
      },
    },
    imageList: [
      "/img/Salvator_Opero_creative_workshop_meeting_room_city_center_pragueJPG.jpg",
      "/img/Salvator_opero_meeting_room_for_rent_prague1_design.jpg",
      "/img/Salvator_popisovatelna_stena_reprezentativni_mistnost_k_pronajmu_workshop.jpg",
      "/img/Salvator_Praha1_staromestske_namesti_pronajem_mensiho_prostoru.jpg",
      "/img/Flexibilni_zasedaci_mistnost_pro_mensi_tymovy_workshop.jpg",
    ],
    titleImage:
      "/img/Salvator_Opero_byznys_hub_kreativni_zasedaci_mistnost_workshop.jpg",
    width: 210,
    seoTitle: "Salvátor | Hravá zasedačka pro 14 až 20 osob | Opero\n",
    seoDescription:
      "V centru Prahy. Barevná zasedací místnost ideální pro ✔ brainstormin ✔ kreativní workshop ✔ seminář. Zajistíme občerstvení. Přijďte se podívat.\n",
  },
  {
    key: "maximilian",
    title: {
      cs: "Maxmilián",
      en: "Maxmilián",
    },
    subtitle: "spaces.meetingrooms.maxmilian.subtitle",
    text: [
      "spaces.meetingrooms.maxmilian.text.part1",
      "spaces.meetingrooms.maxmilian.text.part2",
      "spaces.meetingrooms.maxmilian.text.part3",
    ],
    equipment: ["projector", "flipchart", "writingWall", "pencils", "water"],
    services: ["coffee", "catering", "else"],
    price: {
      cs: {
        hour: "700 Kč / hodina",
        day: "",
        size: "13 m<sup>2</sup> / 6 osob",
      },
      en: {
        hour: "CZK 600 / hour",
        day: "",
        size: "13 m<sup>2</sup> / 6 people",
      },
    },
    imageList: [
      "/img/Max_Opero_pronajem_zasedaci_mistnosti_centrum_Praha.jpg",
      "/img/Max_reprezentativni_zasedaci_mistnost_k_pronajmu_Praha_1.jpg",
      "/img/Business_meeting_Opero_rent_attractive_spacious_design.jpg",
    ],
    titleImage:
      "/img/Max_nejatraktivnejsi_pracovni_prostredi_zasedacka_pronajem.jpg",
    width: 245,
    seoTitle: "Maxmilián | Prosklená zasedačka pro 6 osob | Opero\n",
    seoDescription:
      "V centru Prahy. Inspirativní zasedací místnost ideální pro ✔ jednání s klienty ✔ prezentace ✔ setkání týmu. Zajistíme občerstvení. Přijďte se podívat.\n",
  },
  {
    key: "viola",
    title: {
      cs: "Viola",
      en: "Viola",
    },
    subtitle: "spaces.meetingrooms.viola.subtitle",
    text: [
      "spaces.meetingrooms.viola.text.part1",
      "spaces.meetingrooms.viola.text.part2",
      "spaces.meetingrooms.viola.text.part3",
    ],
    equipment: ["comfySeating", "terrace", "pencils", "water"],
    services: ["coffee", "catering", "else"],
    price: {
      cs: {
        hour: "450 Kč / hodina",
        day: "",
        size: "13 m<sup>2</sup> / 4 osoby",
      },
      en: {
        hour: "CZK 300 / hour",
        day: "",
        size: "13 m<sup>2</sup> / 4 people",
      },
    },
    imageList: [
      "/img/Design_Zasedacka_pro_mentoring_coaching_praha1_stare_mesto.jpg",
      "/img/Coaching_mentoring_pronajem_zasedaci_mistnosti_Staromestske_namesti.jpg",
      "/img/Prijemne_prostredi_profesionalni_zasedaci_mistnost_pronajem_opero.jpg",
    ],
    titleImage:
      "/img/Zasedaci_mistnost_viola_opero_byznys_mentoring_prostor_k_pronajmu.jpg",
    width: 140,
    seoTitle: "Viola | Útulný prostor pro schůzky | Opero\n",
    seoDescription:
      "V centru Prahy. Intimní místnost ideální pro ✔ neformální jednání ✔ meeting ✔ koučink a mentoring. Zajistíme občerstvení. Přijďte se podívat.\n",
  },
  {
    key: "terasa",
    title: {
      cs: "Terasa",
      en: "Terrace",
    },
    subtitle: "spaces.meetingrooms.terasa.subtitle",
    text: [
      "spaces.meetingrooms.terasa.text.part1",
      "spaces.meetingrooms.terasa.text.part2",
      "spaces.meetingrooms.terasa.text.part3",
    ],
    equipment: ["tableChair", "parasol", "deckChair", "flipchart", "pencils", "water"],
    services: ["coffee", "catering", "else"],
    price: {
      cs: {
        hour: "3 000 Kč / hodina",
        day: "",
        size: "29 m<sup>2</sup> / 20 osob",
      },
      en: {
        hour: "CZK 3,000 / hour",
        day: "",
        size: "29 m<sup>2</sup> / 20 people",
      },
    },
    imageList: [
      "/img/Opero_terasa_pracovni_workshop_venkovni_prostor_k_pronajmu_Stare_mesto.jpg",
      "/img/Opero_terasa_pronajem_venkovni_prostor_pro_meeting_praha1.jpg",
      "/img/Opero_terasa_soukroma_kavarna_byznys_hub_pronajem_pro_akci.jpg",
      "/img/Opero_terasa_soukromy_prostor_k_pronajmu_party_venkovni_Staromestske_namesti.jpg",
    ],
    titleImage: "/img/Opero_terasa_firemni_akce_outdoor_team_meeting.jpg",
    width: 180,
    seoTitle: "Terasa | Prostor pro vaše akce a schůzky | Opero\n",
    seoDescription:
      "V centru Prahy. Klidná terasa ideální pro ✔ brainstorming ✔ networking ✔ jednání ✔ focení. Zajistíme občerstvení. Přijďte se podívat.\n",
  },
  {
    key: "kavarna",
    title: {
      cs: "Kavárna",
      en: "Café",
    },
    text: [],
    equipment: ["flipchart", "pencils", "water"],
    services: ["coffee", "catering", "else"],
    subtitle: "",
    price: {
      cs: {
        hour: "5 000,- Kč bez DPH/ hod (cena je včetně terasy)",
        day: "(cena je včetně terasy)",
        size: "43 m<sup>2</sup> / až 24 osob",
      },
      en: {
        hour: "CZK 2,500 / hour",
        day: "(The price includes the terrace)",
        size: "43 m<sup>2</sup> / 24 people",
      },
    },
    imageList: [],
    titleImage: "",
    width: 200,
    seoTitle: "Kavárna | Opero\n",
    seoDescription:
      "V centru Prahy. Vzdušná zasedací místnost ideální pro ✔ tiskovou konferenci ✔  workshop ✔  networking. Zajistíme občerstvení. Přijďte se podívat.\n",
  },
	{
    key: "amelie",
    title: {
      cs: "Amélie",
      en: "Amélie",
    },
    subtitle: "spaces.meetingrooms.amelie.subtitle",
    text: [
      "spaces.meetingrooms.amelie.text.part1",
      "spaces.meetingrooms.amelie.text.part2",
      "spaces.meetingrooms.amelie.text.part3",
    ],
    equipment: ["flipchart", "pencils", "water"],
    services: ["coffee", "catering", "else"],
    price: {
      cs: {
        hour: "300 Kč / hodina",
        day: "",
        size: "17 m<sup>2</sup> / 6 osob",
      },
      en: {
        hour: "CZK 300 / hour",
        day: "",
        size: "17 m<sup>2</sup> / 6 people",
      },
    },
    imageList: [
      "/img/amelie/IMG_7471.jpg",
      "/img/amelie/IMG_7478.jpg",
    ],
    titleImage: "/img/amelie/IMG_7471.jpg",
    width: 180,
    seoTitle: "Amélie | Prostor pro vaše akce a schůzky | Opero\n",
    seoDescription:
      "Amélie je skrytý kout Opera, který nabízí ideální prostředí pro schůzky a brainstormingy pod širým nebem, kde si užijete čerstvý vzduch a příjemný polostín s ostrůvky přírody, a to vše uprostřed městské zástavby.",
  },
	{
    key: "manes",
    title: {
      cs: "Mánes",
      en: "Mánes",
    },
    subtitle: "spaces.meetingrooms.manes.subtitle",
    text: [
      "spaces.meetingrooms.manes.text.part1",
      "spaces.meetingrooms.manes.text.part2",
      "spaces.meetingrooms.manes.text.part3",
    ],
    equipment: ["projector", "lcd", "writingWall", "pencils", "water"],
    services: ["coffee", "catering", "else"],
    price: {
      cs: {
        hour: "1 200 Kč / hodina",
        day: "",
        size: "28 m<sup>2</sup> / 8 osob",
      },
      en: {
        hour: "1 200 CZK / hour",
        day: "",
        size: "28 m<sup>2</sup> / 8 people",
      },
    },
    imageList: [
      "/img/Opero_terasa_pracovni_workshop_venkovni_prostor_k_pronajmu_Stare_mesto.jpg",
      "/img/Opero_terasa_pronajem_venkovni_prostor_pro_meeting_praha1.jpg",
      "/img/Opero_terasa_soukroma_kavarna_byznys_hub_pronajem_pro_akci.jpg",
      "/img/Opero_terasa_soukromy_prostor_k_pronajmu_party_venkovni_Staromestske_namesti.jpg",
    ],
    titleImage: "/img/Opero_terasa_firemni_akce_outdoor_team_meeting.jpg",
    width: 180,
    seoTitle: "Mánes | Prostor pro vaše akce a schůzky | Opero\n",
    seoDescription:
      "V centru Prahy. Klidná terasa ideální pro ✔ brainstorming ✔ networking ✔ jednání ✔ focení. Zajistíme občerstvení. Přijďte se podívat.\n",
  },
  {
    key: "akce",
    title: {
      cs: "Pronájem Opera pro vaši akci",
      en: "Space for your event",
    },
    subtitle: "spaces.meetingrooms.akce.subtitle",
    text: [
      "spaces.meetingrooms.akce.text.part1",
      "spaces.meetingrooms.akce.text.part2",
      "spaces.meetingrooms.akce.text.part3",
    ],
    imageList: [
      "/img/stenc_coworking_byznys_hub_Opero_pronajem_design.jpg",
      "/img/Stenc_detail_Opero_architektura_atraktivni_pracovni_prostredi.jpg",
      "/img/stenc_misto_pro_praci_networking_schuzky_zasedaci_mistnost_pronajem.jpg",
      "/img/Stenc_pronajem_reprezentativni_zasedaci_mistnosti_Praha_1.jpg",
    ],
    titleImage: "/img/Stenc_business_meeting_rent_room_Prague1_Oldtown.jpg",
    width: {
      cs: 650,
      en: 465
    },
    seoTitle: "Prostor pro vaši akci v srdci Prahy | Opero",
    seoDescription:
      "Na události v Operu lidé dlouho vzpomínají. Vaše akce bude mezi nimi. Objevte místo s geniem loci, které sluší večírkům, konferencím i svatbám.\n",
  },
  {
    key: "atrium",
    title: {
      cs: "Atrium",
      en: "Atrium",
    },
    text: [],
    equipment: ["flipchart", "pencils", "water"],
    services: ["coffee", "catering", "else"],
    subtitle: "",
    price: {
      cs: {
        hour: "5 000,- Kč bez DPH/ hod (cena je včetně terasy)",
        day: "možnost zastřešení nůžkovým stanem (10.000 Kč/event)",
        size: "73 m<sup>2</sup> / Kapacita: 50 na sezení, 80 na stání",
      },
      en: {
        hour: "CZK 2,500 / hour",
        day: "Option to cover the space with a folding marquee: CZK 10,000 / event",
        size: "73 m<sup>2</sup> / Capacity: 50 seated, 80 standing",
      },
    },
    imageList: [],
    titleImage: "",
    width: 200,
    seoTitle: "Atrium | Opero\n",
    seoDescription:
      "V centru Prahy. Vzdušná zasedací místnost ideální pro ✔ tiskovou konferenci ✔  workshop ✔  networking. Zajistíme občerstvení. Přijďte se podívat.\n",
  },
];
